export default __webpack_public_path__ + "static/media/howto_3.d0d07eaa.png";